import Base from './Base';

export default class CaseCreationType extends Base {
  value = '';
  label = '';

  constructor(props) {
    super();
    this.clone(props);
  }
}
